import React from 'react';

const TopicInfo = ({ topic, currentBasketId, baskets }) => {
  const currentBasket = baskets.find(basket => basket.id === currentBasketId);
  const otherTopics = currentBasket ? currentBasket.topics.filter(t => t.id !== topic.id) : [];
  const importantConcept = topic.concepts ? topic.concepts.find(concept => concept.is_highlighted) : null;
  
  // Get tag information (support both topic.tag and topic.tags)
  const topicTag = topic.tag || topic.tags;
  const tagName = topicTag?.name || null;

  return (
    <div className="bg-white rounded-2xl border-2 border-gray-900 p-3 sm:p-4 shadow-sm">
      {/* Header row */}
      <div className="flex items-center justify-between mb-2 gap-2">
        <span className="text-xs font-bold text-gray-400 uppercase tracking-wide flex-shrink-0">
          New Topic to Place
        </span>
        {tagName && (
          <span className="text-xs text-amber-600 font-medium bg-amber-50 px-2 py-0.5 rounded-full border border-amber-200 flex-shrink-0">
            {tagName}
          </span>
        )}
      </div>

      {/* Topic name */}
      <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-2 break-words">{topic.name}</h2>

      {/* Current basket information */}
      {currentBasket && (
        <div className="mb-2 text-xs sm:text-sm text-gray-600 break-words">
          <span className="font-medium">Current Basket: </span>
          <span className="italic">{currentBasket.name}</span>
        </div>
      )}

      {/* Hard detail */}
      {importantConcept && (
        <div className="bg-amber-50 border-l-4 border-amber-500 p-4 sm:p-5 rounded-r-lg mb-2 max-h-32 sm:max-h-40 overflow-y-auto">
          <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-2">
            Hard Detail
          </p>
          <p className="text-sm sm:text-base text-gray-900 font-medium leading-relaxed break-words">
            {importantConcept.text}
          </p>
        </div>
      )}

      {/* Associated topics */}
      {otherTopics.length > 0 && (
        <div className="text-xs sm:text-sm text-gray-600 break-words">
          <span className="font-medium">Associated Topics: </span>
          <span className="italic">
            {otherTopics.slice(0, 3).map(t => t.name).join(', ')}
            {otherTopics.length > 3 && ` and ${otherTopics.length - 3} more`}
          </span>
        </div>
      )}
    </div>
  );
};

export default TopicInfo;